/**
 * AK-738 — статус-борд синхронизации AgroHistory (вкладка «Интеграции»
 * настроек компании). Read-only: одна ручка, без мутаций.
 */
import { api } from '@/lib/api';

export type AgroHistoryEntityKey = 'sowings' | 'operations' | 'geometry' | 'field_matches';

export type AgroHistoryEntityStatusValue = 'not_run' | 'ok' | 'truncated' | 'error' | 'running';

export interface AgroHistoryEntityStatus {
  key: AgroHistoryEntityKey;
  label: string;
  status: AgroHistoryEntityStatusValue;
  last_success_at: string | null;
  last_run_at: string | null;
  last_run_ok: boolean | null;
  error: string | null;
  counters: Record<string, unknown>;
}

export interface AgroHistorySyncStatus {
  tenant_schema: string;
  entities: AgroHistoryEntityStatus[];
}

export function getAgroHistorySyncStatus(): Promise<AgroHistorySyncStatus> {
  return api.get<AgroHistorySyncStatus>('/api/v1/integrations/agrohistory/status');
}

/** Подписи счётчиков — язык агронома, не имена полей отчёта. */
export const AGROHISTORY_COUNTER_LABELS: Record<string, string> = {
  source_rows_scanned: 'строк источника проверено',
  sowings_inserted: 'посевов добавлено',
  sowings_updated: 'посевов обновлено',
  sowings_archived: 'посевов в архиве',
  ops_inserted: 'операций добавлено',
  ops_updated: 'операций обновлено',
  ops_archived: 'операций в архиве',
  rows: 'контуров в слое',
  inserted: 'контуров добавлено',
  updated: 'контуров обновлено',
  unchanged: 'без изменений',
  revived: 'контуров восстановлено',
  retired: 'контуров снято с учёта',
  active_fields: 'активных полей',
  rows_written: 'привязок записано',
  no_match: 'без пересечения',
  queued_gray: 'на ручной разбор',
  queued_fanout: 'неоднозначных',
  skipped_reason: 'причина пропуска',
};
